import { render, staticRenderFns } from "./MlbbMatchStats.vue?vue&type=template&id=9f5694e2&scoped=true"
import script from "./MlbbMatchStats.vue?vue&type=script&lang=js"
export * from "./MlbbMatchStats.vue?vue&type=script&lang=js"
import style0 from "./MlbbMatchStats.vue?vue&type=style&index=0&id=9f5694e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5694e2",
  null
  
)

export default component.exports